const attendeeDefault = {
  name: '',
  role: '',
  mobile: '',
  email: '',
  document: '',
  store_code: '',
  hair_knowledge: '',
  company: '',
  cp_code: '',
  cp_name: '',
  lgpd: false,
  // focal_point: '',
};

const cctokenDefault = {
  number: '',
  name: '',
  country: '',
  expireAt: '',
  code: '',
  installments: 1,
};

const customerDefault = {
  name: '',
  email: '',
  mobile: '',
  document: '',
  address: '',
};

const transactionDefault = {
  promoCode: 'NOCODE',
  eventId: process.env.REACT_APP_EVENT_ID,
  eventCode: 155518,
  attendees: [],
  products: [],
  paymentType: 'pix',
  customer: null,
  token: '',
  installments: 1,
};

const transactionResponseDefault = { success: false, data: null };

export {
  attendeeDefault,
  cctokenDefault,
  customerDefault,
  transactionDefault,
  transactionResponseDefault,
};
